import { Check } from '@mui/icons-material'
import { Button, CircularProgress, FormControl, FormControlLabel, Paper, Radio, RadioGroup, TextField, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useState } from 'react'
import { inviteUser } from '../../../networking/network'
import { useAppSelector } from '../../../store/hooks'

interface Props {

}

const AdminView = (props: Props) => {
  const [emailToInvite, setEmailToInvite] = useState<string>('')
  const [invitedEmail, setInvitedEmail] = useState<string | undefined>(undefined)
  const [userRole, setUserRole] = useState<string>('Admin')

  const [loading, setLoading] = useState<boolean>(false)

  const accessToken = useAppSelector(state => state.user.token)

  const sendInvite = async () => {
    if (!accessToken) {
      return
    }
    setLoading(true)
    await inviteUser(accessToken, emailToInvite, userRole).catch((error) => {
      console.error(error)
      setLoading(false)
    })
    setInvitedEmail(emailToInvite)
    setEmailToInvite('')
    setLoading(false)
  }

  return (
    <Paper sx={{
      padding: '12px'
    }}>
      <Typography>
        Invite a user
      </Typography>
      {loading &&
        <CircularProgress />
      }
      {!loading &&
        <form onSubmit={(e) => {
          e.preventDefault()
          sendInvite()
        }}>
          <FormControl>
            <Box display='flex' flexDirection='column' alignItems='flex-start'>
              <TextField 
                variant='outlined'
                onChange={(event) => {
                  setEmailToInvite(event.target.value)
                }}
                value={emailToInvite} />
              <RadioGroup name='user-role' value={userRole} onChange={(event) => { setUserRole(event.target.value) }}>
                <FormControlLabel value="Admin" control={<Radio />} label="Admin" />
              </RadioGroup>
              <Button variant='contained' type='submit'>
                Invite User
              </Button>
              {invitedEmail !== undefined &&
                  <Box display='flex' flexDirection='row' alignItems='center' sx={{
                    marginTop: '6px'
                  }}>
                    <Check color='action' />
                    <Typography variant='body1' color='gray' sx={{
                      fontSize: '12px',
                      marginLeft: '6px'
                    }}>
                      Successfully invited {invitedEmail}
                    </Typography>
                  </Box>
                }
            </Box>
            </FormControl>
        </form>
      }
    </Paper>
  )
}

export default AdminView
